module.exports = __webpack_public_path__ + "img/banner-5.f2f736a6.png";